module.exports = __webpack_public_path__ + "static/media/pl-lk-2.31f293cb.jpg";